import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { EntityRecord } from '#shared/cms/records'

type EntityValue = Omit<EntityRecord, '$type'>


export default /*@__PURE__*/_defineComponent({
  __name: 'new',
  setup(__props) {

definePageMeta({ layout: false })
useHead({ title: 'New entity - admin - Daniel Roe' })

async function save (value: EntityValue) {
  await $fetch('/api/admin/entities', { method: 'POST', body: value })
  await navigateTo('/admin/entities')
}

return (_ctx: any,_cache: any) => {
  const _component_AdminEntityForm = _resolveComponent("AdminEntityForm")!
  const _component_AdminShell = _resolveComponent("AdminShell")!

  return (_openBlock(), _createBlock(_component_AdminShell, { title: "New entity" }, {
    default: _withCtx(() => [
      _createVNode(_component_AdminEntityForm, {
        "submit-label": "Create",
        onSubmit: save
      })
    ]),
    _: 1
  }))
}
}

})